const koCommon = {
  // Navigation
  'nav.features': '기능',
  'nav.pricing': '가격',
  'nav.login': '로그인',
  'nav.signup': '시작하기',
  'nav.dashboard': '대시보드',
  
  // Hero Section
  'hero.title': '링크 관리의',
  'hero.title2': '새로운 기준',
  'hero.subtitle': 'QR 코드, 짧은 링크, 바이오 링크를',
  'hero.subtitle2': '한 곳에서 쉽게 관리하세요',
  'hero.cta.primary': '무료 체험',
  'hero.cta.secondary': '작동 방식 보기',
  'hero.noCreditCard': '회원가입 없이 3개까지 무료로 체험 가능',
  
  // Hero Cards
  'hero.card.qr.title': 'QR 코드',
  'hero.card.qr.desc': '즉시 생성하고 다운로드',
  'hero.card.short.title': '짧은 링크',
  'hero.card.short.desc': '긴 URL을 간단하게',
  'hero.card.bio.title': '바이오 링크',
  'hero.card.bio.desc': '모든 링크를 한 곳에',
  
  // Guest Modal
  'guest.modal.title': '무료 체험 시작',
  'guest.modal.subtitle': '회원가입 없이 각 기능을 3개씩 무료로 체험해보세요',
  'guest.modal.qr': 'QR 코드',
  'guest.modal.short': '짧은 링크',
  'guest.modal.bio': '바이오 링크',
  'guest.modal.tip': '💡 팁:',
  'guest.modal.tipText': '생성한 콘텐츠를 저장하고 관리하려면 회원가입이 필요해요',
  'guest.modal.cancel': '취소',
  'guest.modal.start': '시작하기',
  
  // Features
  'features.title': '필요한 모든 것',
  'features.subtitle': '비즈니스 성장을 위한 강력한 도구',
  
  'feature.bio.title': '바이오 링크 페이지',
  'feature.bio.desc': '모든 중요한 링크가 담긴 아름다운 랜딩 페이지를 만드세요. 인스타그램, 틱톡, 소셜 미디어에 완벽해요. 코딩 없이 언제든 업데이트하세요.',
  
  'feature.qr.title': '커스텀 QR 코드',
  'feature.qr.desc': '브랜드 QR 코드를 즉시 생성하세요. 메뉴, 명함, 마케팅 자료에 완벽해요. 모든 스캔을 실시간으로 추적하세요.',
  
  'feature.links.title': '짧은 링크',
  'feature.links.desc': 'URL을 단축하고 클릭을 추적하세요. 링크 성과에 대한 상세한 분석을 받으세요. 더 깔끔하고 전문적인 링크를 공유하세요.',
  
  'feature.analytics.title': '실시간 분석',
  'feature.analytics.desc': '클릭, 위치, 기기 등을 추적하세요. 캠페인을 위한 데이터 기반 결정을 내리세요. 무엇이 가장 효과적인지 확인하세요.',
  
  'feature.custom.title': '커스텀 브랜딩',
  'feature.custom.desc': '바이오 페이지 디자인, QR 코드 색상, 링크 모양을 커스터마이즈하세요. 브랜드와 완벽하게 매치하세요.',
  
  'feature.team.title': '사용하기 쉬움',
  'feature.team.desc': '기술적 지식이 필요 없어요. 30초 만에 바이오 링크 페이지를 만드세요. 어떤 기기에서든 언제든 링크를 업데이트하세요.',
  
  // Pricing
  'pricing.title': '간단하고 투명한 가격',
  'pricing.subtitle': '무료로 시작하고, 필요할 때 업그레이드하세요',
  'pricing.monthly': '월간',
  'pricing.yearly': '연간',
  'pricing.save': '20% 절약',
  
  'plan.pro.name': 'Pro',
  'plan.pro.price': '$14',
  'plan.pro.period': '월',
  'plan.pro.desc': '크리에이터와 비즈니스를 위한',
  'plan.pro.feature1': '무제한 바이오 링크 페이지',
  'plan.pro.feature2': '무제한 QR 코드',
  'plan.pro.feature3': '무제한 짧은 링크',
  'plan.pro.feature4': '고급 분석 및 인사이트',
  'plan.pro.feature5': '커스텀 QR 코드 디자인',
  'plan.pro.feature6': '우선 지원',
  'plan.pro.cta': 'Pro 시작하기',
  
  // CTA Section
  'cta.title': '시작할 준비가 되셨나요?',
  'cta.subtitle': '우리 플랫폼을 사용하는 수천 명의 크리에이터에 합류하세요',
  'cta.button': '지금 바이오 링크 만들기',
  'cta.noCreditCard': '신용카드 불필요 • 무료 시작',
  
  // Footer
  'footer.about': 'LinkQR은 크리에이터와 비즈니스가 모든 중요한 링크를 한 곳에서 공유할 수 있도록 도와줘요. 아름다운 바이오 링크 페이지를 만들고, 커스텀 QR 코드를 생성하고, 강력한 분석으로 모든 것을 추적하세요.',
  'footer.features': '주요 기능',
  'footer.feature1': '바이오 링크 페이지',
  'footer.feature2': '커스텀 QR 코드',
  'footer.feature3': '짧은 링크',
  'footer.feature4': '실시간 분석',
  'footer.contactTitle': '문의하기',
  'footer.contact': '연락처',
  'footer.rights': '모든 권리 보유',
  
  // Contact Form
  'contact.title': '문의하기',
  'contact.subtitle': '궁금한 점이 있으신가요? 연락 주세요',
  'contact.name': '이름',
  'contact.email': '이메일',
  'contact.message': '메시지',
  'contact.submit': '메시지 보내기',
  'contact.success': '메시지가 성공적으로 전송되었어요!',
  'contact.error': '모든 필드를 입력해주세요',
  
  // Common
  'common.learnMore': '자세히 보기',
  'common.getStarted': '시작하기',
  'common.tryFree': '무료로 체험하기',

  // How It Works Page
  'howItWorks.title': '작동 방식',
  'howItWorks.subtitle': '3단계로 간단하게 시작하세요. 회원가입 없이도 바로 체험할 수 있어요!',
  
  'howItWorks.step1.title': 'QR 코드 생성',
  'howItWorks.step1.desc': '원하는 URL을 입력하고 즉시 QR 코드를 생성하세요. 다운로드하여 어디서든 사용할 수 있어요.',
  
  'howItWorks.step2.title': '짧은 링크 생성',
  'howItWorks.step2.desc': '긴 URL을 짧고 기억하기 쉬운 링크로 변환하세요. 클릭 수를 실시간으로 추적할 수 있어요.',
  
  'howItWorks.step3.title': '바이오 링크 생성',
  'howItWorks.step3.desc': '하나의 링크로 모든 소셜 미디어와 콘텐츠를 연결하세요. 나만의 프로필 페이지를 만들어보세요.',
  
  'howItWorks.features.title': '강력한 기능들',
  'howItWorks.features.subtitle': '필요한 모든 기능이 한 곳에',
  
  'howItWorks.feature1.title': '실시간 분석',
  'howItWorks.feature1.desc': 'QR 스캔, 링크 클릭, 페이지 조회수를 실시간으로 확인하세요.',
  
  'howItWorks.feature2.title': '모바일 최적화',
  'howItWorks.feature2.desc': '모든 기기에서 완벽하게 작동하는 반응형 디자인이에요.',
  
  'howItWorks.feature3.title': '안전한 저장',
  'howItWorks.feature3.desc': '모든 데이터는 안전하게 암호화되어 저장돼요.',
  
  'howItWorks.feature4.title': '커스터마이징',
  'howItWorks.feature4.desc': '바이오 링크 테마를 자유롭게 꾸밀 수 있어요.',
  
  'howItWorks.cta.title': '지금 바로 시작해보세요',
  'howItWorks.cta.subtitle': '회원가입 없이도 무료로 체험할 수 있어요',
  'howItWorks.cta.button': '무료로 시작하기',
  
  'howItWorks.footer.desc': 'QR 코드, 짧은 링크, 바이오 링크를 한 곳에서',

  testimonials: {
    badge: '고객 후기',
    title: '사용자들의 이야기',
    subtitle: '전 세계 크리에이터들이 LinkQR로 성장하고 있어요',
  },
};

export default koCommon;